import { useEffect, useState } from 'react';
import { text } from 'stream/consumers';
import styles from './basic-loader.module.scss';
import stylesBlocks from './self-building-square-loader.module.scss';

export enum LoaderType {
  Spinner,
  Blocks,
}

export const SelfBuildingSquareSpinner = () => {
  return (
    <div className={`${stylesBlocks.loader}`}>
      {Array.from({ length: 9 }).map((val, index) => (
        <div key={index} className={`${stylesBlocks.square} ${index % 3 === 0 ? ' clear' : ''}`} />
      ))}
    </div>
  );
};

export const BasicLoader = ({
  isLoading,
  type = LoaderType.Blocks,
  children,
  fullHeight,
  topOffset = false,
}: {
  isLoading: boolean;
  type?: LoaderType;
  children?: JSX.Element;
  fullHeight?: boolean;
  topOffset?: boolean;
}) => {
  return isLoading
    ? {
        [LoaderType.Blocks]: (
          <div
            className={`${fullHeight ? stylesBlocks.fullHeightContainer : ''} ${
              topOffset ? stylesBlocks.topMenuOffset : ''
            }`}
          >
            <SelfBuildingSquareSpinner></SelfBuildingSquareSpinner>
          </div>
        ),
        [LoaderType.Spinner]: (
          <div className={styles.loaderContainer}>
            <div className={styles.innerContainer}>
              <div className={styles.spinner}></div>
            </div>
          </div>
        ),
      }[type]
    : children || null;
};
